export class ExceptionConstant {
  public static readonly TABLE_NM_EXISTED = "ERR_000";
  public static readonly PROTOCOL_EXISTED = "ERR_001";
  public static readonly VERSION_EXISTED = "ERR_002";
  public static readonly VERSION_NOT_AVAILABLE = "ERR_003";
}
